import Routers from "./routers";
import { Toaster, toast } from "sonner";
import ReactPixel from "react-facebook-pixel";
import { useEffect } from "react";

ReactPixel.init("630019181040627"); // BHXN   Pixel ID

ReactPixel.init("751008092884896"); // Bucketlist   Pixel ID

ReactPixel.pageView(); // Track page views

function App() {
  // useEffect(() => {
  //   ReactPixel.init("630019181040627");
  //   ReactPixel.init("751008092884896");
  //   ReactPixel.pageView();
  // }, []);
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Routers />
    </div>
  );
}

export default App;
